module.exports = __webpack_public_path__ + "img/ripeav.ad66982c.png";